import App from 'app/App';
import { TabProvider } from 'contexts/TabContext';
import MainLayout from 'layouts/MainLayout';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import ErrorBoundary from '../components/ErrorBoundary';

import { Login } from './auth/login';
import PatientDetail from './patients/patient-detail';
import PatientSearch from './patients/patient-search';
import { Protected } from './protected';

// Create router with data API
export const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <Protected>
        <TabProvider>
          <MainLayout />
        </TabProvider>
      </Protected>
    ),
    errorElement: <ErrorBoundary />,
    children: [
      {
        index: true,
        element: <App />,
      },
      {
        path: 'patients',
        children: [
          {
            path: 'search',
            element: <PatientSearch />,
          },
          {
            path: ':patientId',
            element: <PatientDetail />,
          },
        ],
      },
    ],
  },
  {
    path: '/login',
    element: <Login />,
    errorElement: <ErrorBoundary />,
  },
]);

export function AppRouter() {
  return <RouterProvider router={router} />;
}
